module.exports = __webpack_public_path__ + "img/tanxian.fb14ae82.jpg";